/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerGetConversationHistoryQueryResponse, MultiDocumentAgentControllerGetConversationHistoryPathParams, MultiDocumentAgentControllerGetConversationHistoryQueryParams, MultiDocumentAgentControllerGetConversationHistory401, MultiDocumentAgentControllerGetConversationHistory403 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerGetConversationHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { multiDocumentAgentControllerGetConversationHistory } from "../../clients/multi-document-agentService/multiDocumentAgentControllerGetConversationHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const multiDocumentAgentControllerGetConversationHistoryQueryKey = (threadId: MultiDocumentAgentControllerGetConversationHistoryPathParams["threadId"], params: MultiDocumentAgentControllerGetConversationHistoryQueryParams = {}) => [{
  url: '/api/v1/multi-document-agent/history/:threadId',
  params: {
    threadId: threadId
  }
}, ...(params ? [params] : [])] as const;
export type MultiDocumentAgentControllerGetConversationHistoryQueryKey = ReturnType<typeof multiDocumentAgentControllerGetConversationHistoryQueryKey>;
export function multiDocumentAgentControllerGetConversationHistoryQueryOptions(threadId: MultiDocumentAgentControllerGetConversationHistoryPathParams["threadId"], params?: MultiDocumentAgentControllerGetConversationHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = multiDocumentAgentControllerGetConversationHistoryQueryKey(threadId, params);
  return queryOptions<MultiDocumentAgentControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerGetConversationHistory401 | MultiDocumentAgentControllerGetConversationHistory403>, MultiDocumentAgentControllerGetConversationHistoryQueryResponse, typeof queryKey>({
    enabled: !!threadId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return multiDocumentAgentControllerGetConversationHistory(threadId, params, config);
    }
  });
}

/**
 * @description Returns conversation history grouped by question-answer pairs with thinking steps
 * @summary Get grouped conversation history for a thread
 * {@link /api/v1/multi-document-agent/history/:threadId}
 */
export function useMultiDocumentAgentControllerGetConversationHistory<TData = MultiDocumentAgentControllerGetConversationHistoryQueryResponse, TQueryData = MultiDocumentAgentControllerGetConversationHistoryQueryResponse, TQueryKey extends QueryKey = MultiDocumentAgentControllerGetConversationHistoryQueryKey>(threadId: MultiDocumentAgentControllerGetConversationHistoryPathParams["threadId"], params?: MultiDocumentAgentControllerGetConversationHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<MultiDocumentAgentControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerGetConversationHistory401 | MultiDocumentAgentControllerGetConversationHistory403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? multiDocumentAgentControllerGetConversationHistoryQueryKey(threadId, params);
  const query = useQuery({
    ...multiDocumentAgentControllerGetConversationHistoryQueryOptions(threadId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<MultiDocumentAgentControllerGetConversationHistory401 | MultiDocumentAgentControllerGetConversationHistory403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}